import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        attribute: {
            apiPath: '/attributes',
            properties: {
                attrCode: {
                    type: 'string',
                    displayName: '码表值',
                },
                attrName: {
                    type: 'string',
                    displayName: '码表名',
                },
            },
            filters: {
                attrName: {
                    type: 'string',
                    displayName: '码表名',
                },
            },
        },
        attributeOption: {
            apiPath: '/attributes/options',
            properties: {
                optionCode: {
                    type: 'string',
                    displayName: '属性值',
                },
                optionName: {
                    type: 'string',
                    displayName: '属性名',
                },
            },
            filters: {
                optionName: {
                    type: 'string',
                    displayName: '属性名',
                    controlConfig: {
                        placeholder: '查询多条请用英文","顿号间隔',
                    },
                },
                attrCode: {
                    type: 'string',
                    displayName: '码表值',
                },
            },
        },
    },
    components: {
        AttributeSelector: {
            component: 'attributeSelector',
        },
        AttributeOptionSelector: {
            component: 'attributeOptionSelector',
        },
    },
};
